module.exports = __webpack_public_path__ + "img/telegram.0c55fb3b.svg";